const rootArea = "/compliance";

export const complianceGlob = (base: string) => ({
	self: `${base}${rootArea}`,
	read: `${base}${rootArea}/read`
});
